export default function getFirstName(fullName: string | undefined) {
  if (fullName !== undefined) {
    return fullName.split(" ")[0];
  } else {
    return true;
  }
}
